/* assets/elore-cart.js
   ------------------------------------------------------------------
   Part 1: Tailwind config, extracted verbatim from the original inline
   <script id="tailwind-config"> block. Values (colors, spacing,
   borderRadius, fontFamily, fontSize) are byte-for-byte unchanged —
   this is what makes every original utility class (bg-background,
   text-display-lg-mobile, font-label-caps, etc.) resolve exactly as
   it did in the source mockup, since the design still runs on the
   Tailwind CDN JIT runtime referenced in the section file.

   Part 2: Small, self-contained, UI-only interactivity for the
   quantity steppers and remove buttons. This does NOT talk to
   Shopify's cart/AJAX API and does NOT alter product/collection data —
   per project rules, products stay static. It only updates the
   on-screen quantity number and lets a row be dismissed visually.
------------------------------------------------------------------- */

tailwind.config = {
  darkMode: "class",
  theme: {
    extend: {
      "colors": {
              "tertiary-fixed": "#ffdea6",
              "secondary-fixed-dim": "#ffb4a6",
              "on-tertiary-fixed": "#271900",
              "primary-container": "#414833",
              "outline-variant": "#c7c7bd",
              "on-tertiary-container": "#e0ab3d",
              "background": "#fdf9f0",
              "surface-dim": "#dddad1",
              "on-primary-container": "#afb69c",
              "on-error-container": "#93000a",
              "on-primary-fixed-variant": "#424934",
              "secondary-container": "#fe7d65",
              "surface-container": "#f1eee5",
              "surface-container-lowest": "#ffffff",
              "surface-bright": "#fdf9f0",
              "on-secondary-fixed-variant": "#842414",
              "inverse-surface": "#31302b",
              "inverse-primary": "#c2caae",
              "tertiary-container": "#5c4100",
              "on-secondary-container": "#711608",
              "on-tertiary": "#ffffff",
              "error-container": "#ffdad6",
              "on-background": "#1c1c16",
              "surface-tint": "#5a614b",
              "tertiary": "#402c00",
              "surface-container-high": "#ece8df",
              "on-surface-variant": "#46483f",
              "on-surface": "#1c1c16",
              "primary-fixed-dim": "#c2caae",
              "tertiary-fixed-dim": "#f5be4e",
              "outline": "#76786f",
              "on-secondary": "#ffffff",
              "secondary-fixed": "#ffdad3",
              "primary": "#2b321e",
              "inverse-on-surface": "#f4f0e7",
              "on-error": "#ffffff",
              "error": "#ba1a1a",
              "surface-container-low": "#f7f3ea",
              "surface-variant": "#e6e2d9",
              "on-secondary-fixed": "#3f0300",
              "surface-container-highest": "#e6e2d9",
              "on-primary-fixed": "#171e0c",
              "on-primary": "#ffffff",
              "surface": "#fdf9f0",
              "secondary": "#a53b29",
              "on-tertiary-fixed-variant": "#5d4200",
              "primary-fixed": "#dee6c9"
      },
      "borderRadius": {
              "DEFAULT": "0.25rem",
              "lg": "0.5rem",
              "xl": "0.75rem",
              "full": "9999px"
      },
      "spacing": {
              "section-gap-mobile": "64px",
              "section-gap-desktop": "120px",
              "gutter": "24px",
              "editorial-inset": "10%",
              "unit": "8px"
      },
      "fontFamily": {
              "label-caps": [
                      "Montserrat"
              ],
              "display-lg-mobile": [
                      "Michelia"
              ],
              "display-lg": [
                      "Michelia"
              ],
              "headline-md": [
                      "Montserrat"
              ],
              "script-accent": [
                      "Romantic Couple"
              ],
              "body-sm": [
                      "Montserrat"
              ],
              "body-lg": [
                      "Montserrat"
              ]
      },
      "fontSize": {
              "label-caps": [
                      "12px",
                      {
                              "lineHeight": "1",
                              "letterSpacing": "0.1em",
                              "fontWeight": "600"
                      }
              ],
              "display-lg-mobile": [
                      "36px",
                      {
                              "lineHeight": "1.2",
                              "fontWeight": "400"
                      }
              ],
              "display-lg": [
                      "48px",
                      {
                              "lineHeight": "1.1",
                              "letterSpacing": "-0.02em",
                              "fontWeight": "400"
                      }
              ],
              "headline-md": [
                      "22px",
                      {
                              "lineHeight": "1.4",
                              "letterSpacing": "0.05em",
                              "fontWeight": "500"
                      }
              ],
              "script-accent": [
                      "30px",
                      {
                              "lineHeight": "1",
                              "fontWeight": "400"
                      }
              ],
              "body-sm": [
                      "14px",
                      {
                              "lineHeight": "1.6",
                              "fontWeight": "400"
                      }
              ],
              "body-lg": [
                      "16px",
                      {
                              "lineHeight": "1.6",
                              "fontWeight": "400"
                      }
              ]
      }
    },
  }
}

document.addEventListener('DOMContentLoaded', function () {

  var cartItemsRoot = document.querySelector('[data-elore-cart-items]');

  if (!cartItemsRoot) return;


  /*
   * Update Shopify cart
   */

  function updateCart(line, quantity) {

    return fetch('/cart/change.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        line: line,
        quantity: quantity
      })

    })
    .then(function (response) {

      if (!response.ok) {
        throw new Error('Cart update failed');
      }

      return response.json();

    });

  }


  /*
   * Reload cart page after Shopify update
   */

  function refreshCart() {
    window.location.reload();
  }


  /*
   * Handle cart buttons
   */

  cartItemsRoot.addEventListener('click', function (event) {

    var decreaseBtn =
      event.target.closest('[data-elore-qty-decrease]');

    var increaseBtn =
      event.target.closest('[data-elore-qty-increase]');

    var removeBtn =
      event.target.closest('[data-elore-remove-item]');


    /*
     * Quantity
     */

    if (decreaseBtn || increaseBtn) {

      var item =
        event.target.closest('[data-elore-cart-item]');

      if (!item) return;


      var line =
        parseInt(item.getAttribute('data-line'), 10);

      if (!line) return;


      var qtyEl =
        item.querySelector('[data-elore-qty-value]');

      if (!qtyEl) return;


      var currentQuantity =
        parseInt(qtyEl.textContent, 10) || 1;


      var newQuantity;


      if (increaseBtn) {

        newQuantity = currentQuantity + 1;

      } else {

        newQuantity = Math.max(0, currentQuantity - 1);

      }


      /*
       * Prevent double clicks while updating
       */

      if (decreaseBtn) {
        decreaseBtn.disabled = true;
      }

      if (increaseBtn) {
        increaseBtn.disabled = true;
      }


      updateCart(line, newQuantity)

        .then(function () {

          refreshCart();

        })

        .catch(function (error) {

          console.error('ELORE cart update error:', error);

          alert('Unable to update your cart. Please try again.');

        })

        .finally(function () {

          if (decreaseBtn) {
            decreaseBtn.disabled = false;
          }

          if (increaseBtn) {
            increaseBtn.disabled = false;
          }

        });


      return;
    }


    /*
     * Remove item
     */

    if (removeBtn) {

      var itemToRemove =
        event.target.closest('[data-elore-cart-item]');

      if (!itemToRemove) return;


      var removeLine =
        parseInt(itemToRemove.getAttribute('data-line'), 10);

      if (!removeLine) return;


      removeBtn.disabled = true;


      updateCart(removeLine, 0)

        .then(function () {

          /*
           * Small exit animation
           */

          itemToRemove.style.transition =
            'opacity 300ms ease, transform 300ms ease';

          itemToRemove.style.opacity = '0';

          itemToRemove.style.transform =
            'scale(0.98)';


          window.setTimeout(function () {

            refreshCart();

          }, 300);

        })

        .catch(function (error) {

          console.error('ELORE cart removal error:', error);

          removeBtn.disabled = false;

          alert('Unable to remove this item. Please try again.');

        });

    }

  });

});